import { HeaderSecondary } from './view';
export default HeaderSecondary;
